import React from 'react';
import PricingPolicyForm from './PricingPolicyForm';

const AddPricingPolicy = () => {
  return <PricingPolicyForm mode="add" />;
};

export default AddPricingPolicy;
